import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const PICKUP_STATUS_LOG_ENDPOINT = "/pickup-status-log";

export class PickupStatusLogService extends RestServiceConnection {

    // ---------------------------------------------------------------------------------
    /**
     * ES: Obtiene un log de estado de recogida por su ID
     * EN: Gets a pickup status log by its ID
     */
    // ---------------------------------------------------------------------------------
    getPickupStatusLogById = async (id: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PICKUP_STATUS_LOG_ENDPOINT + "/get",
            data: { id },
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }

    // ---------------------------------------------------------------------------------
    /**
     * ES: Lista logs de estado de recogidas con filtros y paginación
     * EN: Lists pickup status logs with filters and pagination
     */
    // ---------------------------------------------------------------------------------
    listPickupStatusLogs = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: PICKUP_STATUS_LOG_ENDPOINT + "/list",
            data: filters,
            headers: { "Content-Type": "application/json" }
        }, true) as AxiosResponse;
        return this;
    }
}